import terminalSettlementApi from '@/api/administrator/terminal-settlement'
import { watchTerminalCommand } from '@/services/terminal-operation-poller'

/**
 * Что сказать оператору о сверке, которую бэк запускает вместе с закрытием смены:
 * null (сверки нет) либо { isError, text }.
 */
export function autoSettlementNotice (response) {
  if (response.terminalSettlementError) {
    return {
      isError: true,
      text: `Сверка терминала не запущена: ${response.terminalSettlementError}. Запустите её из меню «Терминал» в кассе`,
    }
  }

  if (response.terminalSettlement) {
    return {
      isError: false,
      text: 'Запущена сверка терминала. Не закрывайте CRM, пока она не завершится',
    }
  }

  return null
}

/**
 * Ждёт финал сверки терминала: { status, error }. По дедлайну резолвится status 'unknown'.
 * cancel() останавливает опрос, promise тогда не завершается.
 */
export function watchSettlement (filialId, { operationId, timeoutSeconds }) {
  return watchTerminalCommand(
    () => terminalSettlementApi.fetch(filialId, operationId),
    timeoutSeconds,
    'Результат сверки пока неизвестен, проверьте позже',
  )
}
